import { getExpensePdfUrl } from '@webapp/modules/expense/data-access/utils/getExpensePdfUrl'

interface UseGenerateExpensePdfPresenterParams {
  expenseId: number
}

export const useGenerateExpensePdfPresenter = ({
  expenseId,
}: UseGenerateExpensePdfPresenterParams) => {
  const openPdf = () => {
    const url = getExpensePdfUrl(expenseId)
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  return {
    commands: {
      openPdf,
    },
  }
}
